import { TypeCommonAPIState } from "@/lib/redux/type";

export function generateInitialState<T>(params: { data: T }): TypeCommonAPIState<T> {
  return {
    loading: false,
    success: false,
    called: false,
    error: null,
    primaryKeys: [],
    ...params
  }
}